import React from 'react';
import { inject, observer } from 'mobx-react';
import { Dropdown } from 'react-bootstrap';

// Contexts where mid-tour progress can be meaningfully resumed
const RESUMABLE_CONTEXTS = ['results', 'llm', 'aimodal'];

const TutorialButton = ({ tutorialStore, userStore, context = 'landing' }) => {
  if (!userStore.isAdmin) return null;

  const hasProgress = tutorialStore.hasProgress(context);
  const canResume = hasProgress && RESUMABLE_CONTEXTS.includes(context);

  const handleStart = () => tutorialStore.startContextTutorial(context);
  const handleRestart = () => {
    tutorialStore.resetContext(context);
    tutorialStore.startContextTutorial(context);
  };

  return (
    <>
      <Dropdown.Item onClick={canResume ? handleStart : handleRestart}>
        {canResume ? 'Continue Tutorial' : 'Start Tutorial'}
      </Dropdown.Item>
      {canResume && (
        <Dropdown.Item onClick={handleRestart}>
          Restart Tutorial
        </Dropdown.Item>
      )}
    </>
  );
};

export default inject('tutorialStore', 'userStore')(observer(TutorialButton));